export default __webpack_public_path__ + "static/media/playroompage-tickCircle.aef4dfa9.svg";